import React, { Component } from 'react'
import { Query } from 'react-apollo'
import { CONTACT_CONTENT_VARIABLES, CONTACT_CONTENT_QUERY } from '../../query/contactcontent'
import Loading from '../../components/loading/loading'
import HtmlParse from 'html-react-parser'
import { Helmet } from 'react-helmet';

class ContactContentPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="static-page-container">
        <Query variables={CONTACT_CONTENT_VARIABLES} query={CONTACT_CONTENT_QUERY}>
          {({ data, loading, error }) => {
            if (loading || !data) {
              return <Loading />
            } else if (error) console.error(error)
            else {
              return (
                <div className="content-container">
                  <Helmet>
                    <title>{data.SuperContent.Title} - Radyo D</title>
                  </Helmet>
                  <h2>{data.SuperContent.Title}</h2>
                  {HtmlParse(data.SuperContent.Text)}
                </div>
              )
            }
          }}
        </Query>
      </div>
    )
  }
}

export default ContactContentPage
